import en from './en.js'
import fa from './fa.js'
const LOCALES = {
    en,fa
};
let lang = document.documentElement.lang;

export default LOCALES[lang]
